import { useFeatureFlagValue } from "@mirage/service-experimentation/useFeatureFlagValue";

type MotionFlagKey =
  | "tracer"
  | "expand"
  | "back-button"
  | "chips"
  | "scroll"
  | "row";
export type MotionFlagValue = "OFF" | "V1" | "V2";

// Default Server Value
// {
//   "expand": "OFF",
//   "back-button": "OFF",
//   "chips": "OFF",
//   "tracer": "OFF",
//   "scroll": "OFF",
//   "row": "OFF"
// }
export function useOmniboxMotionFlag() {
  const motionJSON = useFeatureFlagValue(
    "dash_2025_06_23_omnibox_motion",
  ) as Record<MotionFlagKey, MotionFlagValue>;

  return {
    getMotionVersionFor: (key: MotionFlagKey): MotionFlagValue | undefined => {
      return motionJSON?.[key] ?? "OFF";
    },
  };
}
